import { formatDate } from "date-fns";

import { CreateFavoriteBid, DeleteFavoriteBid } from "@/services/Bid";

import { BidPlanContent, GetBidListRequest } from "@/types/bid";

import { cn } from "@/libs/utils";

import CommonImg from "@/components/Common/Img";

import FavoriteIconTrue from "@/assets/images/favorite-icon-true.png";
import FavoriteIconFalse from "@/assets/images/favorite-icon-false.png";
import { showToast } from "@/utils/toastUtils";

type Props = {
  content: BidPlanContent;
  onSearch: (toastFinish: boolean, newFilter?: GetBidListRequest) => void;
  projectType: string;
};
export default function BidPlanList({ content, onSearch, projectType }: Props) {
  const handleClickFavorite = async (flag: boolean, project_id: string) => {
    try {
      let result: any = {};
      if (flag) {
        result = await CreateFavoriteBid(projectType, project_id);
      } else {
        result = await DeleteFavoriteBid(projectType, project_id);
      }
      if (result.data.success) {
        showToast({
          message: flag
            ? "관심 공고를 추가했습니다."
            : "관심 공고를 삭제했습니다.",
        });
        onSearch(false);
      } else {
        alert(result.data.error.content);
      }
    } catch (e) {
    } finally {
    }
  };
  return (
    <>
      <div className="flex justify-between">
        <div className="text-xs font-semibold">
          검색 결과{" "}
          <span className="text-dark-red">
            {content.count.toLocaleString()}
          </span>
          개
        </div>
      </div>
      <table className="rounded-[8px] shadow-[0_3.5px_5.5px_0_rgba(0,0,0,0.05)]">
        <colgroup>
          {/*관심*/}
          <col className="w-[60px]" />
          {/*공고명*/}
          <col className="min-w-[200px]" />
          {/*발주시기*/}
          <col className="w-[100px]" />
          {/*금액*/}
          <col className="w-[100px]" />
          {/*구분*/}
          <col className="w-[50px]" />
          {/*계약방식*/}
          <col className="w-[100px]" />
          {/*수요기관*/}
          <col className="w-[150px]" />
          {/*계약일*/}
          <col className="w-[100px]" />
        </colgroup>
        <thead className="bg-dark-red-60 text-white text-sm">
          <tr className="">
            <td className="px-[8px] py-[13px] rounded-tl-[8px] text-center">
              관심
            </td>
            <td>공고명</td>
            <td>발주 시기</td>
            <td>금액</td>
            <td>구분</td>
            <td>계약방식</td>
            <td>수요 기관</td>
            <td className="rounded-tr-[8px]">게시일</td>
          </tr>
        </thead>
        <tbody className="text-[12px] text-gray-A font-normal">
          {content.items.map((bid, bidIndex) => (
            <tr
              key={bidIndex}
              className={cn({
                "bg-white": bidIndex % 2 === 0,
              })}
            >
              <td className="px-[8px] py-[13px] flex justify-center">
                {bid.starred ? (
                  <CommonImg
                    src={FavoriteIconTrue}
                    alt="Favorite"
                    className="size-[20px] cursor-pointer z-10"
                    onClick={() => {
                      handleClickFavorite(false, bid.project_id);
                    }}
                  />
                ) : (
                  <CommonImg
                    src={FavoriteIconFalse}
                    alt="Favorite"
                    className="size-[20px] cursor-pointer z-10"
                    onClick={() => {
                      handleClickFavorite(true, bid.project_id);
                    }}
                  />
                )}
              </td>
              <td>{bid.title}</td>
              <td>{bid.planned_dt ?? "공고서 참조"}</td>
              <td>{bid.budget_amount.toLocaleString()}</td>
              <td>{bid.category_name}</td>
              <td>{bid.contract_method}</td>
              <td>{bid.dminst_nm}</td>
              <td>{formatDate(bid.uploaded_dt, "yyyy-MM-dd")}</td>
            </tr>
          ))}
          <tr
            className={cn("h-[8px]", {
              "bg-white": content.items.length % 2 === 0,
            })}
          ></tr>
        </tbody>
      </table>
    </>
  );
}
